export default __webpack_public_path__ + "static/media/artwork-3000x3000-min.42f23d7c.png";